import { render, staticRenderFns } from "./VipConfirm.vue?vue&type=template&id=45eec8f2&scoped=true&"
import script from "./VipConfirm.vue?vue&type=script&lang=js&"
export * from "./VipConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eec8f2",
  null
  
)

export default component.exports